function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m468.967 338.899-29.128-27.18 10.874-27.181-10.074-30.002h-139.856l20.002 180.593h191.215v-74.984z",
  fill: "#ffda44"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 416.393,
  cy: 435.129,
  fill: "#03232e",
  r: 46.869
}), /*#__PURE__*/React.createElement("circle", {
  cx: 416.393,
  cy: 435.129,
  fill: "#b4d2d7",
  r: 16.869
}), /*#__PURE__*/React.createElement("path", {
  d: "m350.787 284.538h30.002v54.36h-30.002z",
  fill: "#0b799d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m410.79 284.538v54.361h58.177l-18.254-54.361z",
  fill: "#07485e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m320.785 180.175h-64.785l-20.001 93.463 20.001 161.491h64.785z",
  fill: "#ffb655"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 180.175h256v254.954h-256z",
  fill: "#ffda44"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 30.002-20.001 100.919 20.001 142.717 71.359-71.359c18.262-18.262 29.558-43.492 29.558-71.359 0-55.736-45.182-100.918-100.917-100.918z",
  fill: "#e50058"
}), /*#__PURE__*/React.createElement("path", {
  d: "m155.083 130.919c0 27.867 11.296 53.097 29.558 71.359l71.359 71.36v-243.636c-55.735 0-100.917 45.182-100.917 100.917z",
  fill: "#ff415b"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 60.002-20.001 70.919 20.001 70.919c39.104 0 70.919-31.814 70.919-70.919s-31.815-70.919-70.919-70.919z",
  fill: "#ff415b"
}), /*#__PURE__*/React.createElement("path", {
  d: "m185.081 130.921c0 39.105 31.814 70.919 70.919 70.919v-141.838c-39.104 0-70.919 31.814-70.919 70.919z",
  fill: "#ff7c48"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296.919 130.921c0-22.563-18.356-40.919-40.919-40.919l-20.001 40.919 20.001 40.919c22.562 0 40.919-18.356 40.919-40.919z",
  fill: "#e1ebf0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m215.081 130.921c0 22.563 18.356 40.919 40.919 40.919v-81.838c-22.563 0-40.919 18.356-40.919 40.919z",
  fill: "#fff5f5"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 95.608,
  cy: 435.129,
  fill: "#07485e",
  rx: 46.869,
  ry: 46.87,
  transform: "matrix(.16 -.987 .987 .16 -349.217 459.803)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m95.608 418.26c-9.302 0-16.87 7.567-16.87 16.869s7.568 16.869 16.87 16.869 16.869-7.567 16.869-16.869-7.567-16.869-16.869-16.869z",
  fill: "#e1ebf0"
}));

var SvgDeliveryTruckLocation = function SvgDeliveryTruckLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryTruckLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery-truck-location.011cd794.svg";
export { ForwardRef as ReactComponent };